import { c as _c } from "react/compiler-runtime";
import { RadioGroupItemWithLabel } from "@/components/custom/RadioGroupItemWithLabel";
import { RadioGroup } from "@/components/ui/radio-group";
import OptionLabel from "./OptionLabel";
import ValidationError from "./ValidationError";
type Props = {
  field: string;
  label: string;
  helper?: string;
  controlIdBase: string;
  labelId: string;
  helpDialogId: string;
  errorId: string | undefined;
  value: string | undefined;
  onValueChange: (value: string) => void;
  options: {
    sku: string;
    displayName: string;
  }[];
  radioGroupClassName?: string;
  itemClassName?: string;
};
export default function OptionRadioField(props) {
  const $ = _c(26);
  const {
    field,
    controlIdBase,
    labelId,
    errorId,
    radioGroupClassName: t0
  } = props;
  const radioGroupClassName = t0 === undefined ? "flex flex-wrap gap-4" : t0;
  let t1;
  if ($[0] !== labelId || $[1] !== props.helpDialogId || $[2] !== props.helper || $[3] !== props.label) {
    t1 = <OptionLabel id={labelId} label={props.label} helper={props.helper} helpDialogId={props.helpDialogId} />;
    $[0] = labelId;
    $[1] = props.helpDialogId;
    $[2] = props.helper;
    $[3] = props.label;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = props.value;
  const t3 = props.onValueChange;
  let t4;
  if ($[5] !== controlIdBase || $[6] !== props.itemClassName || $[7] !== props.options) {
    let t5;
    if ($[9] !== controlIdBase || $[10] !== props.itemClassName) {
      t5 = opt => <RadioGroupItemWithLabel key={opt.sku} value={opt.sku} id={`${controlIdBase}-${opt.sku}`} className={props.itemClassName}>{opt.displayName}</RadioGroupItemWithLabel>;
      $[9] = controlIdBase;
      $[10] = props.itemClassName;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = props.options.map(t5);
    $[5] = controlIdBase;
    $[6] = props.itemClassName;
    $[7] = props.options;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[12] !== errorId || $[13] !== labelId || $[14] !== props.onValueChange || $[15] !== props.value || $[16] !== radioGroupClassName || $[17] !== t4) {
    t5 = <RadioGroup aria-labelledby={labelId} aria-describedby={errorId} aria-required="true" value={t2} onValueChange={t3} className={radioGroupClassName}>{t4}</RadioGroup>;
    $[12] = errorId;
    $[13] = labelId;
    $[14] = props.onValueChange;
    $[15] = props.value;
    $[16] = radioGroupClassName;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== field) {
    t6 = <ValidationError field={field} />;
    $[19] = field;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== field || $[22] !== t1 || $[23] !== t5 || $[24] !== t6) {
    t7 = <div className="flex flex-col gap-1" data-validation-field={field}>{t1}{t5}{t6}</div>;
    $[21] = field;
    $[22] = t1;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}